"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPageCursorData = exports.requestWithSignV2 = void 0;
const operators_1 = require("rxjs/operators");
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
function encodeQueryParams(params) {
    return Object.entries(params || {})
        .reduce((result, [key, value]) => {
        if (value !== undefined || value !== null) {
            result.push(`${key}=${value}`);
        }
        return result;
    }, [])
        .join("&");
}
function getQueryString(requestParams) {
    const query = encodeQueryParams(requestParams);
    return query ? `?${query}` : "";
}
function requestWithSignV2(params) {
    const { api, query, data, method, accountType } = params;
    const instance = (0, trade_utils_lib_1.getTradeDependencyInstance)();
    const host = instance.getRunTimeHost().futureApiHostV2;
    const queryParams = query ? getQueryString(query) : "";
    const url = host + api + queryParams;
    const tokenType = accountType === trade_utils_lib_1.AccountTradeType.bot ? trade_token_lib_1.TradeTokenType.spot : trade_token_lib_1.TradeTokenType.trader;
    return (0, trade_token_lib_1.acquireKeyResolver)()
        .requestSigner.getSignRequestV2(method, url, JSON.stringify(data), tokenType)
        .pipe((0, operators_1.map)((resp) => {
        if (resp.code === 0) {
            return resp.data;
        }
        else {
            throw resp;
        }
    }));
}
exports.requestWithSignV2 = requestWithSignV2;
/**
 * 处理后端带next_page_cursor的数据，并将next_page_cursor的数据追加data的到最后一条数据的next_page_cursor字段
 * @param resp 后端返回的Response
 * @param dataKey 制定列表对应的key
 * @returns 已经追加过next_page_cursor字段的数据列表，可能为空数组
 */
function processPageCursorData(resp, dataKey) {
    if (!resp)
        return [];
    const newData = (resp[dataKey] || []);
    const { next_page_cursor } = resp;
    if (newData.length) {
        newData[newData.length - 1].next_page_cursor = next_page_cursor;
    }
    return newData;
}
exports.processPageCursorData = processPageCursorData;
